import styled from 'styled-components';
import { getMediaQueriesMFByTheme } from '../../utils';

const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    flex: 1;
`;

const Image = styled.img`
    width: 148px;
    height: 148px;
`;

const LoadingText = styled.p`
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 0;
    color: #0d0d0d;

    @media ${({ theme }) => getMediaQueriesMFByTheme(theme).desktop} {
        font-size: 28px;
        line-height: 32px;
    }
`;

export { Image, LoadingContainer, LoadingText };
